/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshBackendExtension} from '../api'

export const useMutationRefreshBackendExtension = createReactQueryMutationHook('refreshBackendExtension', refreshBackendExtension)
